import {useRef} from "react";
import useStore from "../store";
import useClickOutside from "../utils/useOnClickOutside";

export default function LangContainer({locale, dismissPicker}) {
    const setLangStore = useStore(state => state.setLang);
    const picker = useRef(null);

    const languageHandler = (localeChoice) => {
        setLangStore(localeChoice);
        localStorage.setItem('lang', localeChoice);
        dismissPicker()
    }

    useClickOutside(picker, dismissPicker);

    return (
        <ul ref={picker} className={"flag-lang-container"}>
            {
                locale.map((el, id) => {
                    if (el === 'ru') return null
                    return <li 
                                key={id}
                                onClick={() => languageHandler(el)}
                            >
                        <div
                            className={"fll-icon flag-lang-locale-" + el}
                        />
                    </li>
                })
            }
        </ul>
    )
}
